// frontend/src/notifications/usePushSubscription.js
import { useEffect } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_BASE_URL
const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY

function urlB64ToUint8Array(b64) {
  const padding = '='.repeat((4 - (b64.length % 4)) % 4)
  const base64 = (b64 + padding).replace(/-/g, '+').replace(/_/g, '/')
  const raw = window.atob(base64)
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)))
}

/**
 * usePushSubscription — request permission, subscribe, send to backend.
 *
 * Runs once per session. Silent if not supported, no key configured, or
 * permission denied. Re-subscribes on every mount because endpoint may
 * have changed (browser refresh tokens, etc).
 */
export function usePushSubscription() {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!('serviceWorker' in navigator) || !('PushManager' in window) || !VAPID_PUBLIC_KEY) return
    let cancelled = false

    const subscribe = async () => {
      try {
        const reg = await navigator.serviceWorker.ready
        let sub = await reg.pushManager.getSubscription()

        if (sub) {
          if (cancelled) return
          await axios.post(`${API}/api/notify/push-subscribe`, sub.toJSON())
          return
        }

        const perm = await Notification.requestPermission()
        if (perm !== 'granted') return

        sub = await reg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlB64ToUint8Array(VAPID_PUBLIC_KEY),
        })
        if (cancelled) return
        await axios.post(`${API}/api/notify/push-subscribe`, sub.toJSON())
      } catch (e) {
        // Silent — push is opt-in; failures should not disrupt the app
      }
    }

    subscribe()
    return () => { cancelled = true }
  }, [])
}
